
import React, { useEffect, useState } from "react";
import { FlexGrid, Typography, useThemeProvider, Card, Button, useSelect, useTextfield, useDialog, Skeleton } from '@albo-ui/core'
import { CountItem } from "../../elements/CountItem";
import DataTable from "react-data-table-component";
import { customStyles2 } from "../../../util/TableStyles"
import { noDataComponent } from "../../../util/DataObject"
import { useLeadTable } from "./hooks/useLeadTable";
import { useLeadCount } from "./hooks/useLeadCount";
import { FilterLeadType, LeadsTrackingReportProps } from "./types";
import { InputGroup } from "./InputGroup";
import { ItemType } from "../../../util/hooks/useCatalog";
import { Search, FilterList } from '@mui/icons-material';
import { paginationComponentOptions } from "../../../util/i18n-es";
import { FiltersLeadDialog } from "../../modals/filters-lead/FiltersLead";
import { ACTIVITY_START_DATE, useDefaultFilters } from "../../modals/filters-lead/hooks/useFiltersLead";
import { useDownloadLead } from "./hooks/useDownloadLead";
import { FiltersLeadSummary } from "../../modals/filters-lead/FiltersLeadSummary";

const items = [
    { value: "rz", name: "Razón Social" },
    { value: "correo", name: "Correo" },
    { value: "rfc", name: "RFC" },
]

export const LeadsTrackingReport = ({ changeAlert, changeLoader, changeWidgets, config }: LeadsTrackingReportProps) => {

    const { countData, orderedStatus, loading: loadingStaus, statusCatalog } = useLeadCount(changeAlert)
    const defaltFilters = useDefaultFilters(statusCatalog)
    const { columns, data, perPage, loading: loadingTable, totalRows, handlePageChange, handlePerRowsChange, handleFiltersChange, filters, page } = useLeadTable(changeAlert, defaltFilters, statusCatalog, changeWidgets, config)
    const { downloadReport, setFilters: setFiltersDownload, filters: filtersDownload, loading: loadingReport } = useDownloadLead(changeAlert, statusCatalog);
    const [isDownload, setIsDownload] = useState(false);

    const { theme } = useThemeProvider();
    const useSelectProps = useSelect<ItemType>()
    const inputProps = useTextfield()
    const dialogProps = useDialog()
    const dialogSummaryProps = useDialog()

    const search = () => {
        const text = inputProps.value;
        const newFilters = {
                ...defaltFilters,
                dates: {
                    start: ACTIVITY_START_DATE,
                    end: defaltFilters.dates.end
                },
                ...(useSelectProps.value?.value === 'rz' && {lead_social_reason: text}),
                ...(useSelectProps.value?.value === 'correo' && {lead_email: text}),
                ...(useSelectProps.value?.value === 'rfc' && {lead_tax_id: text}),
        }
        handleFiltersChange(newFilters)
        inputProps.onInput("")
    }


    const onFilterChange = async (data: FilterLeadType) => {
        dialogProps.onClose()
        if (isDownload) {
            setFiltersDownload(data)
            dialogSummaryProps.openDialog()
        } else {
            handleFiltersChange(data)
        }
        setIsDownload(false)

    }
    const onCloseDialogFilter = () => {
        dialogProps.onClose()
        setIsDownload(false)
    }
    const mostrarModalFiltros = () => {
        dialogProps.openDialog()
    }

    const showDownloadReport = () => {
        setIsDownload(true)
        dialogProps.openDialog()

    }
    const onConfirmReport = (data) => {
        dialogSummaryProps.onClose()
        downloadReport(data)
    }

    useEffect(() => {
        changeLoader(loadingStaus || loadingReport || loadingTable)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingStaus, loadingReport, loadingTable])

    return <div className="size-12">
        <FlexGrid container direction="column" spacing={3} style={{ marginTop: theme.spacesPx[3], flexWrap: "wrap" }}  >
            <FlexGrid item >
                <Typography variant="h1">
                    Reporte de seguimiento
                </Typography>
            </FlexGrid>
            <FlexGrid container direction="row" spacing={3} fullWidth alignItems="stretch" style={{flexWrap: "wrap"}}>
                {!loadingStaus && orderedStatus?.map((status, ix) => {
                    return <CountItem
                        title={status.metadata.description}
                        count={((countData && countData[status.name] as number) || 0)}
                        key={ix}
                    />
                }
                )}
            </FlexGrid>
            <Card padding={3} flexDirection="row" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" style={{ borderColor: theme.colors.manatee, gap: theme.spacesPx[2] }}>
                <form style={{ width: "100%", display: "flex", flex: 3, gap: theme.spacesPx[2] }} onSubmit={(e) => { e.preventDefault(); search() }}>
                    <InputGroup selectProps={{
                        items: items as ItemType[],
                        ...useSelectProps,
                    }
                    }
                        inputProps={{ placeholder: "Buscar por correo, Razón Social o RFC", ...inputProps, icon: <Search />, onClickIcon: search }}
                    />
                </form>
                <FlexGrid container direction="row" fullWidth spacing={2} flex={1}>
                    <Button buttonType="secondary" onClick={mostrarModalFiltros}>
                        <FlexGrid container direction="row" fullWidth spacing={2} flex={1} alignItems={"center"} justify="center" >
                            Filtros
                            <FilterList />
                        </FlexGrid>
                    </Button>
                    <Button onClick={showDownloadReport}>Descargar</Button>
                </FlexGrid>

            </Card>

            <Card padding={2} flexDirection="column" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" style={{ borderColor: theme.colors.manatee }}>
                {
                    loadingTable ?
                        <Skeleton width="100%" height="100px" />
                        :
                        <DataTable
                            columns={columns}
                            data={data}
                            customStyles={customStyles2}
                            noDataComponent={noDataComponent}
                            progressPending={loadingTable}
                            pagination
                            paginationServer
                            paginationDefaultPage={page}
                            paginationPerPage={perPage}
                            paginationTotalRows={totalRows}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                            paginationComponentOptions={paginationComponentOptions}
                        />
                }
            </Card>
        </FlexGrid>
        <FiltersLeadDialog onClose={onCloseDialogFilter} open={dialogProps.open} onConfirm={onFilterChange} status={statusCatalog} selectedFilters={filters} isDownload={isDownload} style={{maxHeight: "600px"}} />
        <FiltersLeadSummary {...dialogSummaryProps} onConfirm={onConfirmReport} status={statusCatalog} selectedFilters={filtersDownload} style={{maxHeight: "600px"}} />
    </div>
}

